import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';

export default function ExportExcelResult({ disabled, jsonData, fileName }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);

    useEffect(() => {
        if (jsonData) {
            let data = jsonData?.map(({ studentId, ...rest }) => rest);

            // Header row
            setExcelHeaderRow([
                `${resourceFinal[appLanguage].words.STUDENT}${resourceFinal[appLanguage].words.NUMBER.toLowerCase()}`,
                resourceFinal[appLanguage].words.NAME_FIRST,
                resourceFinal[appLanguage].words.NAME_INSERTION,
                resourceFinal[appLanguage].words.NAME_LAST,
                resourceFinal[appLanguage].words.CLASS,
                resourceFinal[appLanguage].words.USER_DATA_CREBO,
                resourceFinal[appLanguage].words.USER_DATA_COHORT,
                `${resourceFinal[appLanguage].words.PROGRAM} ${resourceFinal[appLanguage].words.FINISHED.toLowerCase()}`,
            ]);

            // Data rows
            data = data.map(item => {
                if (item.hasOwnProperty('completedProgram')) {
                    switch (item.completedProgram) {
                        case true:
                            item.completedProgram = "Afgerond";
                            break;
                        case false:
                            item.completedProgram = "Nog niet afgerond";
                            break;
                        default:
                            break;
                    }
                }

                return item;
            });

            let dataRows = [];

            data?.forEach(item => {
                dataRows.push(
                    Object.keys(item).map(key => {
                        const value = item[key];

                        return value === null ? "" : value;
                    })
                );
            });

            setExcelDataRows(dataRows);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={fileName}
            buttonText={`${resourceFinal[appLanguage].words.EXPORT} ${resourceFinal[appLanguage].words.EXCEL.toLowerCase()}`}
            disabledCondition={disabled}
        />
    );
}
